export function distinct(value, index, array) {
    return array.indexOf(value) === index;
}
